import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

export enum SwipeDirection {
  UP,
  RIGHT,
  DOWN,
  LEFT,
}

export interface SwipeEvent {
  dir: SwipeDirection;
  xStart: number;
  xEnd: number;
  yStart: number;
  yEnd: number;
}

@Directive({
  selector: '[swipeDetection]'
})
export class SwipeDetectionDirective {

  @Output()
  public onSwipe = new EventEmitter<SwipeEvent>();

  xDown: number | undefined;
  yDown: number | undefined;
  xDiff: number | undefined;
  yDiff: number | undefined;
  timeDown: number | undefined;

  @HostListener('touchstart', ['$event'])
  handleTouchStart(e: TouchEvent): void {
    this.timeDown = Date.now();
    this.xDown = e.touches[0].clientX;
    this.yDown = e.touches[0].clientY;
    this.xDiff = 0;
    this.yDiff = 0;
  }

  @HostListener('touchmove', ['$event'])
  handleTouchMove(e: TouchEvent): void {

    if (!this.xDown || !this.yDown) {
      return;
    }

    const xUp = e.touches[0].clientX;
    const yUp = e.touches[0].clientY;

    this.xDiff = this.xDown - xUp;
    this.yDiff = this.yDown - yUp;
  }

  @HostListener('touchend', ['$event'])
  handleTouchEnd(e: TouchEvent): void {
    const swipeThreshold = 20; // default 20px
    const swipeTimeout = 500; // default 500ms
    const timeDiff = Date.now() - this.timeDown!;
    let eventType: SwipeDirection | undefined = undefined;
    const changedTouches = e.changedTouches || e.touches || [];

    if (Math.abs(this.xDiff!) > Math.abs(this.yDiff!)) { // most significant
      if (Math.abs(this.xDiff!) > swipeThreshold && timeDiff < swipeTimeout) {
        if (this.xDiff! > 0) {
          eventType = SwipeDirection.LEFT;
        } else {
          eventType = SwipeDirection.RIGHT;
        }
      }
    } else if (Math.abs(this.yDiff!) > swipeThreshold && timeDiff < swipeTimeout) {
      if (this.yDiff! > 0) {
        eventType = SwipeDirection.UP;
      } else {
        eventType = SwipeDirection.DOWN;
      }
    }

    if (eventType !== undefined) {
      const eventData = {
        dir: eventType,
        xStart: this.xDown!,
        xEnd: (changedTouches[0] || {}).clientX || -1,
        yStart: this.yDown!,
        yEnd: (changedTouches[0] || {}).clientY || -1
      };

      this.onSwipe.emit(eventData);
    }

    // reset values
    this.xDown = undefined;
    this.yDown = undefined;
    this.timeDown = undefined;
  }
}
